export default "__VITE_ASSET__DiulgYJ9__"